import { render, staticRenderFns } from "./GasProduce.vue?vue&type=template&id=fdf163d8"
import script from "./GasProduce.vue?vue&type=script&lang=js"
export * from "./GasProduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports